<template>
  <div class="home">
    <div class="row">
      <div class="col-md-12 inst-area">
        <div class="card">
          <h5 class="card-header">Teacher</h5>

          <div class="card-body">
            <div class="documents_wrapper">
              <div class="documents_block">
                <div class="row">
                  <div
                    class="col-md-6"
                    v-for="(instructor, index) in teacher_details"
                    :key="index"
                  >
                    <div class="inst-box">
                      <div class="pro">
                        <img
                          :src="
                            instructor.image !== null
                              ? api_url + '/user/' + instructor.image
                              : api_url + '/user/blank-profile-picture.png'
                          "
                          alt=""
                          width="23px"
                        />
                      </div>
                      <div class="desc">
                        <div class="name">
                          {{ instructor.first_name }} {{ instructor.last_name }}
                        </div>
                        <div class="email">{{ instructor.email }}</div>
                        <div class="no-course">
                          {{ instructor.courseCount }} Courses
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var Config = require('../router/Config')
// var $ = require('jquery')
var Cookies = require('vue-cookies')
var userPermissions = Cookies.get('userPermissions')

module.exports = {
  name: 'teachers',
  props: [],
  data () {
    return {
      api_url: Config.API_URL,
      teacher_details: []
    }
  },
  beforeCreate: function () {
    if (!userPermissions.course_view) {
      this.$router.push('/')
    }
  },
  mounted () {
    this.getTeachers()
  },
  methods: {
    getTeachers: function () {
      this.axios
        .post(
          this.api_url +
            '/api/fe/subject/teachers?token=' +
            Cookies.get('accessToken'),
          {
            course_id: Cookies.get('courseId'),
            student_id: Cookies.get('studentId')
          }
        )
        .then(response => {
          var teacherData = response.data
          // console.log('teacherData')
          // console.log(teacherData)
          this.teacher_details = teacherData
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/component/subject/subject';
</style>
